var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tags__cta-lockup"},[_c('p',[_vm._v("Tags")]),_vm._l((_vm.TagItems),function(cta,index){return _c('div',{key:index,staticClass:"tag"},[_c('CtaButton',{staticClass:"tag-button",attrs:{"item":cta}})],1)})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }